var _rect, _path, _path2, _ellipse, _path3, _rect2, _rect3, _rect4, _rect5, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowTimeSlotsWorkIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 123,
    viewBox: "0 0 183 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 122.209,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5049 51.3381C24.7676 66.5337 39.0173 77.0022 54.3326 74.7202C59.6893 73.922 64.4669 71.6697 68.3183 68.4279M76.2367 36.7304C75.6668 35.3268 74.987 33.9857 74.209 32.7159C68.5334 23.4516 57.6364 17.9787 46.1388 19.6919C38.6618 20.806 32.3131 24.7532 28.0365 30.2698C26.0189 32.8724 24.4625 35.8242 23.4663 38.9926C23.1202 40.0932 22.8418 41.2199 22.6351 42.3672",
    stroke: "black",
    strokeWidth: 0.987137,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.785 21.0209C71.5983 21.2178 71.6048 21.5333 71.7996 21.7256C71.9945 21.918 72.3038 21.9142 72.4906 21.7173L71.785 21.0209ZM97.7742 27.5251C98.0248 27.6296 98.3092 27.5077 98.4093 27.2531L100.04 23.1029C100.14 22.8483 100.018 22.5572 99.7676 22.4527C99.5169 22.3483 99.2326 22.4701 99.1325 22.7248L97.6827 26.4138L94.0518 24.9014C93.8011 24.797 93.5168 24.9188 93.4167 25.1734C93.3166 25.4281 93.4387 25.7192 93.6893 25.8236L97.7742 27.5251ZM72.4906 21.7173C76.3909 17.6052 81.4451 16.146 86.1097 17.12C90.7737 18.0939 95.0971 21.5113 97.5063 27.2564L98.4045 26.8716C95.8781 20.847 91.3031 17.1888 86.2973 16.1436C81.2923 15.0985 75.9055 16.6767 71.785 21.0209L72.4906 21.7173Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 23.2134,
    ry: 23.0317,
    transform: "matrix(0.999979 0.00645844 -0.00656075 0.999978 50.2333 47.2571)",
    fill: "#FF8E3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9413 29.9041L49.941 46.9624L59.5871 47.0242",
    stroke: "black",
    strokeWidth: 0.987137,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 78.8175,
    height: 64.2902,
    rx: 5.52797,
    transform: "matrix(0.971513 0.236999 -0.232485 0.972604 81.8778 31.5778)",
    fill: "#6462FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 68.2076,
    height: 45.2904,
    rx: 1.9631,
    transform: "matrix(0.971517 0.236983 -0.232501 0.9726 84.1395 44.9847)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.364877,
    y: 0.597206,
    width: 4.25146,
    height: 11.7102,
    rx: 2.12573,
    transform: "matrix(0.971442 0.237297 -0.232179 0.972678 103.11 30.5859)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.987137
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.364877,
    y: 0.597206,
    width: 4.25145,
    height: 11.7102,
    rx: 2.12572,
    transform: "matrix(0.971442 0.237297 -0.232179 0.972678 135.256 38.3832)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.987137
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971585 0.2367 -0.23274 0.972542 87.6666 56.4175)",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16512,
    ry: 2.1545,
    transform: "matrix(0.97158 0.236724 -0.232766 0.972535 112.949 62.5512)",
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.15451,
    transform: "matrix(0.971579 0.236724 -0.232765 0.972536 125.59 65.6153)",
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236724 -0.232766 0.972536 138.232 68.6822)",
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16514,
    ry: 2.1545,
    transform: "matrix(0.971585 0.236701 -0.232739 0.972542 85.4034 65.8287)",
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236724 -0.232765 0.972536 98.0452 68.8953)",
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16514,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 110.687 71.9624)",
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236724 -0.232765 0.972536 135.969 78.0933)",
    fill: "black"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.15451,
    transform: "matrix(0.971585 0.236701 -0.23274 0.972542 83.1404 75.2433)",
    fill: "black"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 95.7836 78.3101)",
    fill: "black"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16514,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 108.424 81.3772)",
    fill: "black"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 121.064 84.4442)",
    fill: "black"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 133.707 87.5112)",
    fill: "black"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971585 0.236701 -0.23274 0.972542 80.8757 84.658)",
    fill: "black"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 93.5175 87.7248)",
    fill: "black"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236724 -0.232765 0.972536 106.159 90.7918)",
    fill: "black"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16514,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 118.799 93.8589)",
    fill: "black"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.16513,
    ry: 2.1545,
    transform: "matrix(0.971579 0.236725 -0.232765 0.972536 131.443 96.9259)",
    fill: "black"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.57789,
    ry: 5.54678,
    transform: "matrix(0.971639 0.236477 -0.233017 0.972474 100.637 59.1726)",
    fill: "#0CC67B"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.57789,
    ry: 5.54678,
    transform: "matrix(0.971639 0.236476 -0.233018 0.972474 124.402 74.9733)",
    fill: "#0CC67B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1316 59.095L98.7155 60.3316C98.8384 60.5919 99.157 60.6919 99.4053 60.5481L103.385 58.2417",
    stroke: "black",
    strokeWidth: 0.987137,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.897 74.8958L122.48 76.1324C122.603 76.3927 122.922 76.4927 123.17 76.3489L127.15 74.0424",
    stroke: "black",
    strokeWidth: 0.987137,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowTimeSlotsWorkIllustration);
export default __webpack_public_path__ + "static/media/how-time-slots-work-illustration.e6398c96240674a841c1c8e79fc3995b.svg";
export { ForwardRef as ReactComponent };